import { useState } from "react";

export default function useCaptureGuidelines() {
    const [showGuidelines, setShowGuidelines] = useState(true);

    return {
        showGuidelines,
        setShowGuidelines
    }
}